import { TimeInputType } from '../time-picker.types';

import { formatTimeInput } from './time-picker.helper';

export function invalidTime(value: string, type: TimeInputType = '12-hour') {
  return formatTimeInput(value, type) === undefined;
}
